import styled, { css } from "styled-components";
import Tooltip from "../../../../../base/others/tooltip/index.js";
import { TooltipContent } from "../../../../../base/others/tooltip/styled.js";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import Counter from "../../../../inputs/counter/index.js";
import { CounterButtonWrapper } from "../../../../inputs/counter/components/counter-button/views/desktop/styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import personCounterThemes from "./themes/index.js";
const personCounterWrapperVariants = {
    horizontal: css`
		${FlexMixin({
        align: 'flex-start'
    })}
	`,
    vertical: css`
		${FlexMixin({
        direction: 'column'
    })}
	`
};
export const PersonCounterWrapper = styled.div.withConfig({
    displayName: "styled__PersonCounterWrapper",
    componentId: "sc-d327f91b-0"
})`
	${({ $variant ='vertical'  })=>personCounterWrapperVariants[$variant]}
`;
const personCounterBodyRowVariants = {
    horizontal: css`
		${FlexMixin({
        justify: 'space-between'
    })}
	`,
    vertical: css``
};
const personCounterBodyRowLabelVariants = {
    horizontal: css`
		${FlexMixin({
        align: 'center'
    })}
		gap: 4px;
	`,
    vertical: css`
		${FlexMixin({
        direction: 'column'
    })}
		gap: 12px;
	`
};
export const PersonCounterBodyRow = styled.div.withConfig({
    displayName: "styled__PersonCounterBodyRow",
    componentId: "sc-d327f91b-1"
})`
	flex: 1 1 40%;
	${FlexMixin({
    justify: 'space-between'
})}

	${({ $variant ='vertical'  })=>personCounterBodyRowVariants[$variant]}
	${({ $labelVariant ='horizontal'  })=>personCounterBodyRowLabelVariants[$labelVariant]}
`;
export const PersonCounterTitle = styled.div.withConfig({
    displayName: "styled__PersonCounterTitle",
    componentId: "sc-d327f91b-2"
})`
	${FontMixin({
    size: 'medium',
    weight: 'regular',
    height: 'smaller'
})}
	${FlexMixin({
    align: 'center'
})}
	gap: 8px;
	min-width: 132px;
	color: ${({ theme  })=>theme.colors.grays.darker};

	span {
		${FontMixin({
    weight: 'light'
})}
		color: ${({ theme  })=>theme.colors.grays.base};
	}
`;
export const Info = styled.p.withConfig({
    displayName: "styled__Info",
    componentId: "sc-d327f91b-3"
})`
	${FontMixin({
    size: 'small',
    weight: 'regular',
    height: 'small'
})}
	margin-top: 4px;
	color: ${({ theme  })=>theme.colors.text.dark};
`;
const personCounterOptionsVariants = {
    horizontal: css`
		margin-top: 10px;
		padding-right: 5px;
	`,
    vertical: css`
		margin-top: 20px;
	`
};
export const PersonCounterOptions = styled.div.withConfig({
    displayName: "styled__PersonCounterOptions",
    componentId: "sc-d327f91b-4"
})`
	${FlexMixin({
    direction: 'column'
})}
	gap: 12px;
	flex: 1 1 60%;

	${({ $variant ='vertical'  })=>personCounterOptionsVariants[$variant]}
`;
export const PersonCounterOptionsTitle = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__PersonCounterOptionsTitle",
    componentId: "sc-d327f91b-5"
})`
	${FontMixin({
    size: 'medium',
    weight: 'light',
    height: 'smaller'
})}
	color: ${({ theme  })=>theme.colors.grays.dark};
	// padding-top 9px;
	${({ theme  })=>personCounterThemes[theme.id]?.PersonCounterOptionsTitle?.()};
`;
export const PersonCounterOptionsSelect = styled.div.withConfig({
    displayName: "styled__PersonCounterOptionsSelect",
    componentId: "sc-d327f91b-6"
})`
	${FlexMixin({
    wrap: true
})}
	gap: 12px;
`;
export const IconWrapper = styled.div.withConfig({
    displayName: "styled__IconWrapper",
    componentId: "sc-d327f91b-7"
})`
	i {
		color: ${({ theme  })=>theme.colors.primary.base};
		font-size: 20px;
	}
`;
export const TooltipStyled = styled(Tooltip).withConfig({
    displayName: "styled__TooltipStyled",
    componentId: "sc-d327f91b-8"
})`
	${TooltipContent} {
		color: ${({ theme  })=>theme.colors.text};
		${FontMixin({
    size: 'small',
    weight: 'light',
    height: 'base'
})}
		padding: 8px 16px;
		text-align: left;
		max-width: 280px;
	}
`;
export const CounterButtons = styled(Counter).withConfig({
    displayName: "styled__CounterButtons",
    componentId: "sc-d327f91b-9"
})`
	${CounterButtonWrapper} {
		border-radius: ${({ theme  })=>theme.borderRadiusCounter};
	}
`;

//# sourceMappingURL=styled.js.map